import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'components/Icon';
import { Select, MultiSelect } from 'components/Select';
import { SearchInput } from 'components/SearchInput';
import pageStore from 'stores/Page/Agencies/AgenciesPageStore';

import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';


@observer
class AgenciesItem extends React.Component {
  constructor (props) {
    super(props);
  }

  getLocation = () => {
    const { agency } = this.props;
    const listing = agency.listing;

    let locations = [];
    if (listing.region) locations.push(utils.capitalizeFirstLetter(listing.region.toLowerCase()));

    let option = pageStore.countryOptions.filter((option) => option.id === listing.countryAlpha2)[0];
    if (option) locations.push(option.label);

    return locations.join(", ");
  };

  getStartingPrice = () => {
    const { agency } = this.props;
    const listing = agency.listing;
    const startingPrice = parseInt(listing.startingPrice);
    return `US$ ${startingPrice}`;
  };

  render() {
    const { agency } = this.props;
    const listing = agency.listing;

    return (
      <a href={`/agencies/${agency.slug}`} className="agencies-item">
        <div className="agencies-item-logo">
          <img
            src={listing.logoMedia.src}
            className="agencies-item-logo-img"
          />
        </div>

        <div className="agencies-item-details">
          <div className="agencies-item-name">{agency.name}</div>
          <div className="agencies-item-tagline">{listing.tagline}</div>
        </div>

        <div className="agencies-item-attrs">
          <div className="agencies-item-attr">
            <div className="agencies-attr-title">Location</div>
            <div className="agencies-attr-value">{this.getLocation()}</div>
          </div>

          <div className="agencies-item-attr">
            <div className="agencies-attr-title">Starting Price</div>
            <div className="agencies-attr-value">{this.getStartingPrice()}</div>
          </div>
        </div>
      </a>
    );
  }
}


export default AgenciesItem;
